export default {
  "DOUBTS": "संदेह"
};